// MUI
import { Box, Link, Stack, Typography } from "@mui/material";

// Styles
import { styles } from "./styles";
import { darkBlue } from "../constants/ColourConstants";

const Footer = () => {
  return (
    <Box
      sx={{
        mt: 2,
        width: "100%",
        bgcolor: darkBlue,
      }}
    >
      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          py: 2,
          px: { xs: 1, sm: 6, md: 10 },
        }}
      >
        <Stack spacing={1}>
          <Typography sx={styles.footerText}>
            Our mission is to revolutionize the way that our patients experience
            health care by providing episodic expert care that is timely,
            efficient and client-focused for individuals suffering from
            non-emergent acute illness and injury.
          </Typography>
          <Typography sx={{ ...styles.footerText, fontWeight: "bold" }}>
            For any inquiries regarding your appointment, please call the clinic
            at{" "}
            <Link href="tel:+14312222273" color="inherit">
              (431) 222 - 2273
            </Link>
            . <br /> For technical support, please email{" "}
            <Link href="mailto:bookings.techsupport@qdoc.ca" color="inherit">
              bookings.techsupport@qdoc.ca
            </Link>
            .
          </Typography>
          <Typography sx={styles.footerText}>
            Copyright ©{" "}
            <Link href="https://www.wpgminorillness.com/" color="inherit">
              The Minor Illness & Injury Clinic
            </Link>{" "}
            {new Date().getFullYear()}.
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};
export default Footer;
